import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';

import { TeacherService } from 'app/teacher/services/teacher.service';
import { IGameShowRunSettings } from '../models/gameshow-run-settings';
import { GameShowDataService } from '../services/game-show-data.service';

@Injectable({
  providedIn: 'root'
})
export class GameShowSettingsResolver {
  private readonly gameShowDataService = inject(GameShowDataService);
  private readonly teacherService = inject(TeacherService);

  public resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<IGameShowRunSettings> {
    const classId = this.teacherService.activeClassInfo?.ClassId ?? '';
    const publicUnitId = route.paramMap.get('publicUnitId') ?? '';
    return this.gameShowDataService.getGameShowSettings(classId, publicUnitId);
  }
}
